document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-muted], [data-muted-full]').forEach(button => {
    button.addEventListener('click', () => {
      // Find the sibling video element
      let video = button.parentElement.querySelector('video');
      if (!video) return;
      const isMuted = !video.muted;
      video.muted = isMuted;
      button.classList.toggle('muted', isMuted);
      button.setAttribute('data-muted', isMuted);
    });
  });
});
